import { useNotificationsFacade } from '../../../apis/facades/useNotificationsFacade';
import { useDispatch, useSelector } from 'react-redux';
import {
  loadNotifications,
  selectNotificationsCenterNotifications,
  selectNotificationsCenterTotalUnread,
  selectNotificationsHasUpdates,
} from '../../../reducers/notificationsCenterReducers';
import { useEffect } from 'react';

const useNotifications = () => {
  const dispatch = useDispatch();
  const { get_notifications } = useNotificationsFacade();
  const notifications = useSelector(selectNotificationsCenterNotifications);
  const totalUnread = useSelector(selectNotificationsCenterTotalUnread);
  const hasUpdates = useSelector(selectNotificationsHasUpdates);

  useEffect(() => {
    (async function () {
      if (hasUpdates) {
        const { notifications, totalUnread } = await get_notifications();
        dispatch(loadNotifications({ notifications, totalUnread }));
      }
    })();
  }, [dispatch, get_notifications, hasUpdates, notifications, totalUnread]);

  return { notifications, totalUnread };
};

export default useNotifications;
